import script from "./AskConsultantDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./AskConsultantDrawer.vue?vue&type=script&setup=true&lang=js"

import "./AskConsultantDrawer.vue?vue&type=style&index=0&id=18174753&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18174753"]])

export default __exports__